<template>
  <b-container fluid class="container-layout">
    <b-row align-h="center" class="mt-5">
      <p class="title mt-5">¡HOLA {{nombre | upper}}!</p>
    </b-row>
    <b-row align-h="center" class="mt-5">
      <b-col cols="8">
        <p class="text-help" style="text-align:center">
          Puedes dejar un mensaje en caso tenga una consulta respecto a
          tus resultados, enviando un correo:
        </p>
      </b-col>
    </b-row>

    <b-row align-h="center" class="mt-5">
      <p class="mail">
        simulacro@ucsp.edu.pe
        <img style="cursor:pointer" @click="copy()" src="@/assets/images/copy.png" alt />
      </p>
    </b-row>
  </b-container>
</template>

<script>
import "@/assets/scss/app_web.scss";
export default {
  name: "Home",
  data: () => ({
    nombre: ""
  }),
  created() {
    this.$store.dispatch("setModulo", "AYUDA");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    this.nombre = userdata.nombre;
  },
  methods: {
    copy() {
      const el = document.createElement("textarea");
      el.value = "simulacro@ucsp.edu.pe";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
  },
  filters: {
    upper(value) {
      return value.toUpperCase();
    }
  }
};
</script>